import { render, staticRenderFns } from "./bankCardPay.vue?vue&type=template&id=fd264ab2&scoped=true&"
import script from "./bankCardPay.vue?vue&type=script&lang=js&"
export * from "./bankCardPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd264ab2",
  null
  
)

export default component.exports